import { DashboardConfigDTOShowMetricByEnum } from 'generated/leaderboard-client';

import { ChartConfigurationSettings, DEFAULT_CHART_GLOBAL_CONFIG } from '@neptune/charts-domain';
import { SmoothingAlgorithm } from '@neptune/shared/smoothing-domain';

import { Complete } from 'common/utility-types';

export const MetricDistinction = DashboardConfigDTOShowMetricByEnum;
export type MetricDistinction = DashboardConfigDTOShowMetricByEnum;

type ChartGlobalConfigFieldNames =
  | 'yAxisScale'
  | 'xAxisScale'
  | 'xAxisMetric'
  | 'xAxisMode'
  | 'metricsStepsRange'
  | 'smoothing'
  | 'showOriginalLineOnSmoothing'
  | 'xAxisRange'
  | 'showCompletion'
  | 'normalizeToFirstValue'
  | 'outliersDisplayMode';

export type ChartGlobalConfig = Partial<
  Pick<ChartConfigurationSettings, ChartGlobalConfigFieldNames>
> & {
  showMetricBy?: MetricDistinction;
  smoothingAlgorithm?: SmoothingAlgorithm;
};

// This check must be here to avoid circular dependency.
DEFAULT_CHART_GLOBAL_CONFIG satisfies Complete<ChartGlobalConfig>;
